module.exports = __webpack_public_path__ + "img/amazon.3ef030db.svg";